import { instance } from "config/axiosInstance";

const baseURL = process.env.REACT_APP_TENANT_BE;
const BASE = "/contract-sales-recap";

/**
 * GET /contract-sales-recap
 * List semua jadwal rekap (lintas kontrak).
 * @param {Object} params - { page, limit, status, contractId, search }
 */
export async function getAllSalesRecapSchedules(params = {}) {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "" && v !== "all") qs.set(k, v);
  });
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return await instance({ baseURL }).get(BASE + query);
}

/**
 * GET /contract-sales-recap/contracts/:contractId
 * List jadwal untuk satu kontrak.
 */
export async function getContractSalesRecapSchedules(contractId, queryParams = "") {
  return await instance({ baseURL }).get(`${BASE}/contracts/${contractId}${queryParams}`);
}

/**
 * PATCH /contract-sales-recap/:scheduleId/submit
 * Simpan data penjualan sebagai DRAFT.
 */
export async function submitSalesRecapData(scheduleId, body) {
  return await instance({ baseURL }).patch(`${BASE}/${scheduleId}/submit`, body);
}

/**
 * PATCH /contract-sales-recap/:scheduleId/finalize
 * Kunci DRAFT → VERIFIED + hitung share.
 */
export async function finalizeSalesRecapData(scheduleId) {
  return await instance({ baseURL }).patch(`${BASE}/${scheduleId}/finalize`);
}

/**
 * PATCH /contract-sales-recap/:scheduleId/verify
 * Finance verifikasi + kalkulasi.
 */
export async function verifySalesRecapData(scheduleId, body) {
  return await instance({ baseURL }).patch(`${BASE}/${scheduleId}/verify`, body);
}

/**
 * PATCH /contract-sales-recap/:scheduleId/settle
 * Tandai SETTLED.
 */
export async function settleSalesRecap(scheduleId) {
  return await instance({ baseURL }).patch(`${BASE}/${scheduleId}/settle`);
}

/**
 * PATCH /contract-sales-recap/:scheduleId/dispute
 * Tandai DISPUTED.
 */
export async function disputeSalesRecap(scheduleId, body) {
  return await instance({ baseURL }).patch(`${BASE}/${scheduleId}/dispute`, body);
}

/**
 * DELETE /contract-sales-recap/:scheduleId
 * Hapus item (hanya status PENDING).
 */
export async function deleteSalesRecapSchedule(scheduleId) {
  return await instance({ baseURL }).delete(`${BASE}/${scheduleId}`);
}

/**
 * POST /contract-sales-recap/:scheduleId/generate-invoice
 */
export async function generateInvoiceFromRecap(scheduleId) {
  return await instance({ baseURL }).post(`${BASE}/${scheduleId}/generate-invoice`);
}
